import { gql } from "@apollo/client/core";

export const CREATOMATE_TEMPLATE_FIELDS = gql`
  fragment CreatomateTemplateFields on CreatomateTemplate {
    id
    name
    displayName
    creatomateId
    requiredContactFields {
      name
      placeholder
      charLimit
    }
    requiredCustomFields {
      name
      placeholder
      friendlyName
      charLimit
    }
    colorVariables {
      name
      friendlyName
      modificationKeys
    }
    logoUrlKey
    previewSnapshotTimeSeconds
  }
`;

export const LIST_CREATOMATE_TEMPLATES = gql`
  ${CREATOMATE_TEMPLATE_FIELDS}
  query listCreatomateTemplates($input: ListCreatomateTemplatesInput!) {
    listCreatomateTemplates(input: $input) {
      ...CreatomateTemplateFields
    }
  }
`;

const PERSONALIZED_GIF_FIELDS = gql`
  ${CREATOMATE_TEMPLATE_FIELDS}
  fragment PersonalizedGifFields on PersonalizedGif {
    id
    name
    creatomateTemplate {
      ...CreatomateTemplateFields
    }
    customFields {
      name
      friendlyName
      value
    }
    customColors {
      name
      friendlyName
      modificationKeys
      value
    }
    customLogo {
      key
      url
    }
    previewSnapshotTimeSeconds
    contactFieldMetadata {
      name
      fallback
    }
    createdBy {
      id
      fullName
    }
    createdAt
  }
`;

export const LIST_PERSONALIZED_GIFS = gql`
  ${PERSONALIZED_GIF_FIELDS}
  query listPersonalizedGifs($input: ListPersonalizedGifsInput!) {
    listPersonalizedGifs(input: $input) {
      ...PersonalizedGifFields
    }
  }
`;

export const GET_CREATOMATE_TEMPLATE_PREVIEW_LINK = gql`
  query getCreatomateTemplatePreviewLink(
    $input: GetCreatomateTemplatePreviewLinkInput!
  ) {
    getCreatomateTemplatePreviewLink(input: $input) {
      gifUrl
      pngUrl
    }
  }
`;

export const GET_PERSONALIZED_GIF_PREVIEW_LINK = gql`
  query getPersonalizedGifPreviewLink(
    $input: GetPersonalizedGifPreviewLinkInput!
  ) {
    getPersonalizedGifPreviewLink(input: $input) {
      gifUrl
      pngUrl
    }
  }
`;

export const CREATE_PERSONALIZED_GIF = gql`
  ${PERSONALIZED_GIF_FIELDS}
  mutation createPersonalizedGif($input: CreatePersonalizedGifInput!) {
    createPersonalizedGif(input: $input) {
      ...PersonalizedGifFields
    }
  }
`;

export const EDIT_PERSONALIZED_GIF = gql`
  ${PERSONALIZED_GIF_FIELDS}
  mutation editPersonalizedGif($input: EditPersonalizedGifInput!) {
    editPersonalizedGif(input: $input) {
      ...PersonalizedGifFields
    }
  }
`;

export const DELETE_PERSONALIZED_GIF = gql`
  mutation deletePersonalizedGif($input: DeletePersonalizedGifInput!) {
    deletePersonalizedGif(input: $input) {
      success
    }
  }
`;
